import type { ComponentType } from "react";
import { isChunkLoadError } from "@/lib/chunk-reload";

function RenderNothing() {
  return null;
}

export function renderNothingIfChunkFails<P>(
  load: Promise<ComponentType<P>>,
): Promise<ComponentType<P>> {
  return load.catch((error: unknown) => {
    if (isChunkLoadError(error)) return RenderNothing;
    throw error;
  });
}
